module.exports = __webpack_public_path__ + "img/background.9b548ecd.jpeg";